import React from "react";
import { spring, useCurrentFrame, useVideoConfig, interpolate } from "remotion";

interface OutroProps {
  keywords: string[];
  frame: number;
  fps: number;
}

export const KineticFlashOutro: React.FC<OutroProps> = ({
  keywords,
  frame,
  fps,
}) => {
  const pulseScale = 1.0 + Math.sin((frame / fps) * Math.PI * 1.5) * 0.04;

  return (
          <div
            style={{
              width: "100%",
              background: "#ffd166",
              border: "4px solid #ff007f",
              borderRadius: "0px",
              boxShadow: "10px 10px 0px rgba(0,0,0,0.85)",
              padding: "50px 40px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <div
              style={{
                fontFamily: "'Anton', sans-serif",
                fontWeight: 900,
                fontSize: "16px",
                color: "#ff007f",
                letterSpacing: "4px",
                textTransform: "uppercase",
                marginBottom: "35px",
                transform: "skewX(-10deg)",
              }}
            >
              📢 STRIKE CTA
            </div>

            <h2
              style={{
                fontFamily: "'Anton', sans-serif",
                fontSize: "52px",
                fontWeight: 900,
                lineHeight: 1.15,
                color: "#030205",
                textTransform: "uppercase",
                letterSpacing: "1px",
                marginBottom: "40px",
                transform: "skewX(-4deg)",
              }}
            >
              Never Miss A Tech Shock
            </h2>

            {/* Pulsing CTA Action Button */}
            <div
              style={{
                transform: `scale(${pulseScale})`,
                transition: "transform 0.1s ease",
                cursor: "pointer",
                width: "80%",
                maxWidth: "350px",
                background: "#ff007f",
                border: "3px solid #000000",
                padding: "20px 0",
                boxShadow: "6px 6px 0px #000000",
                marginBottom: "40px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                transformOrigin: "center",
              }}
            >
              <span
                style={{
                  fontFamily: "'Anton', sans-serif",
                  fontWeight: 900,
                  fontSize: "28px",
                  color: "#ffffff",
                  textTransform: "uppercase",
                  letterSpacing: "3px",
                  transform: "skewX(-8deg)",
                }}
              >
                👉 Hit Follow 👈
              </span>
            </div>

            <div
              style={{
                fontFamily: "'Anton', sans-serif",
                fontSize: "26px",
                fontWeight: 900,
                color: "#ff007f",
                letterSpacing: "1px",
                transform: "skewX(-6deg)",
              }}
            >
              @TheDigitalBullet
            </div>
          </div>
        )
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
